import ENDPOINT from "@/config/endpoint";
import request from "@/utils/request";

export async function fetchArticle(params) {
  return await request({
    url: ENDPOINT.ARTICLE,
    method: "get",
    params,
  });
}

export async function fetchAllCategory(params) {
  return await request({
    url: `${ENDPOINT.BACKEND_URL}/get-all-category`,
    method: "get",
    params,
  });
}

export async function fetchById(id) {
  return await request({
    url: `${ENDPOINT.ARTICLE}/${id}`,
    method: "get",
  });
}

export async function createArticle(data) {
  return await request({
    url: ENDPOINT.ARTICLE,
    method: "post",
    data,
  });
}

export async function updateArticle(id, data) {
  return await request({
    url: `${ENDPOINT.ARTICLE}/${id}`,
    method: "post",
    data,
  });
}

export async function removeArticle(id) {
  return await request({
    url: `${ENDPOINT.ARTICLE}/${id}`,
    method: "delete",
  });
}